import * as Environment from './EnvironmentConstants';
import {COUNTRIES} from './AppConstants';
import {Catalog} from '../../common/types/common';

let MC_URL = 'http://localhost:9013/';
let SERVERLESS_UTILS_URL = 'https://utils-ag.latamautos.com';
let SLACK_WEBHOOK_URL = 'https://hooks.slack.com/services/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';
let NANO_VALIDATION_ID_URL = 'https://demo-apis-services.latamautos.com/credito-real-id-validations';

switch (Environment.ENVIRONMENT) {
    case Environment.PRODUCTION_ENV:
        MC_URL = 'https://apis.latamautos.com/';
        SERVERLESS_UTILS_URL = 'https://utils-ag.latamautos.com';
        SLACK_WEBHOOK_URL = 'https://hooks.slack.com/services/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';
        NANO_VALIDATION_ID_URL = 'https://apis-services.latamautos.com/credito-real-id-validations';
        break;
    case Environment.STAGING_ENV:
        MC_URL = '//staging.apis.latamautos.com/';
        SERVERLESS_UTILS_URL = 'https://utils-ag.latamautos.com';
        SLACK_WEBHOOK_URL = 'https://hooks.slack.com/services/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';
        NANO_VALIDATION_ID_URL = 'https://demo-apis-services.latamautos.com/credito-real-id-validations';
        break;
    case Environment.DEMO_ENV:
        MC_URL = '//demo.apis.latamautos.com/';
        SERVERLESS_UTILS_URL = 'https://utils-ag.latamautos.com';
        SLACK_WEBHOOK_URL = 'https://hooks.slack.com/services/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';
        NANO_VALIDATION_ID_URL = 'https://demo-apis-services.latamautos.com/credito-real-id-validations';
        break;
}

export const MCC_URL = country => `${MC_URL}${COUNTRIES[country].prefixMotorcredit}`;
export const MCC_URL_WITH_BANK = (country, bank) =>
    `${MC_URL}${COUNTRIES[country].prefixMotorcreditWithBank}`.replace(/{{bank}}/g, bank);
export const POINT_OF_SALE_TYPE = 'END_USER_ONLINE';
export const TIMEOUT = 45000; // milliseconds
export const DEFAULT_YEAR: Catalog = {id: '2017', value: '2017', payload: ''};
export const DEFAULT_VEHICLE_PRICE = 100000;
export const DEFAULT_DOWN_PAYMENT = 31500;
export const MAX_VEHICLE_PRICE = 9999999;
export const FACEBOOK_PAGE_ID = country => COUNTRIES[country].facebookPageId;
export const NAME_COOKIE: string = 'motorfy';
export const EXPIRATION_TIME_COOKIE: number = 30; // days
export const CR_DEPENDENT_CATALOG_ID = 'DEPENDENT';
export {
    SLACK_WEBHOOK_URL
};

export const SERVERLESS_ENDPOINT = `${SERVERLESS_UTILS_URL}`;
export const LOAN_APPLICANT_PROFILE = [
    {profile: 'CH1'},
    {profile: 'CH3'},
    {profile: 'SH1'},
    {profile: 'SH3'}
];
export const VALIDATION_ID_URL = NANO_VALIDATION_ID_URL;
export const LAMBDA_API_GATEWAY_TOKEN =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoibGF0YW1hdXRvcyIsImlhdCI6MTU0ODcwMzEwM30.Y7SOEusL36GAXH4KmrsZ407jwo_P2u-Aqqomp6G9ctY';
